// React imports
import React from 'react';

// UI – style imports
import { WithStyles, withStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';

// local imports
import { styles } from './Press.style';
import Carousel from 'components/Carousel';
import PressCarousel from 'components/PressCarousel';

function Press(props: WithStyles<typeof styles>) {
    const { classes } = props;

    return (
        <Box className={classes.root}>
            <Carousel
                dotStyle="press"
                contentWidth={818}
                carouselSlides={[
                    style => <PressCarousel type="entrepreneur" style={style} />,
                    style => <PressCarousel type="ceo" style={style} />,
                    style => <PressCarousel type="efe" style={style} />,
                    style => <PressCarousel type="fractal" style={style} />,
                ]}
            />
        </Box>
    );
}

export default withStyles(styles)(Press);
